/* 清水材木店 商品ページ：選択肢の名前（見出しの横・吹き出し・画像の拡大）。大型の商品だけ（szk-product-style.liquid）
   - 下に出る「価格とカート」の帯は szk-buy.js、在庫切れの追加料金の表示は szk-oos.js（どちらも、すべての商品ページで読む） */
(() => {
  'use strict'
  const root = document.querySelector('.product--container')
  if (!root) return

  // ---- 見出しの横に、いま選んでいる名前（画像・色・画像つきボタンの項目だけ。画像の下には名前を出さないため） ----
  function showPicked() {
    for (const el of root.querySelectorAll('.gpo-element')) {
      const label = el.querySelector(':scope > .gpo-label')
      if (!label) continue
      const items = [...el.querySelectorAll(':scope > .gpo-ov-wrapper > .gpo-swatches')]
      const visual = items.some((x) => !x.classList.contains('buttons') || x.querySelector('img'))
      let tag = label.querySelector('.szk-picked')
      if (!visual) { tag?.remove(); continue }
      const text = [...el.querySelectorAll('.gpo-swatches input:checked')].map((i) => i.value).filter(Boolean).join('、')
      if (!tag) { tag = document.createElement('span'); tag.className = 'szk-picked'; label.append(tag) }
      if (tag.textContent !== text) tag.textContent = text
    }
  }
  let pt = 0
  const pickedLater = () => { clearTimeout(pt); pt = setTimeout(showPicked, 80) }
  root.addEventListener('change', pickedLater)
  root.addEventListener('click', pickedLater)
  new MutationObserver(pickedLater).observe(root, { childList: true, subtree: true })
  showPicked()

  // 上に固定されたヘッダーの下の端（吹き出しの位置で使う。高さは、上に貼りついている要素から毎回測る）
  const headers = [...document.querySelectorAll('[id*="header"], [class*="header"]')].filter((e) => e.getBoundingClientRect().width > window.innerWidth * 0.5).slice(0, 12)
  const headerBottom = () => {
    let b = 0
    for (const h of headers) {
      const pos = getComputedStyle(h).position
      if (pos !== 'sticky' && pos !== 'fixed') continue
      const r = h.getBoundingClientRect()
      if (r.top <= 1 && r.bottom > b && r.height < window.innerHeight / 2) b = r.bottom
    }
    return b
  }

  // ---- 吹き出し：画像の選択肢は、拡大した画像と名前を出す（PC はカーソル、スマホはタップ） ----
  // Globo の「拡大」が入っていない項目にも、選択肢の画像を大きくして足す（すでに拡大がある項目はそのまま）
  const bigger = (src) => {
    try {
      const u = new URL(src, location.href)
      if (u.searchParams.has('width')) u.searchParams.set('width', '480')
      u.pathname = u.pathname.replace(/_(\d+)x(\d*)(\.\w+)$/, '_480x$3')
      return u.href
    } catch { return src }
  }
  function ensureZoom(label) {
    const img = label.querySelector('.gpo-swatch__inner img, img')
    const tip = label.querySelector('.gpo-tooltip')
    if (!img || !tip) return
    const src = [img.currentSrc, img.getAttribute('src'), img.getAttribute('data-src')].find((v) => v && !v.startsWith('data:'))
    if (!src) return
    const own = tip.querySelector('.gpo-tooltip__image img')
    if (own && !own.closest('.szk-zoom')) return
    let box = tip.querySelector('.szk-zoom')
    if (!box) {
      box = document.createElement('div')
      box.className = 'gpo-tooltip__image szk-zoom'
      box.append(Object.assign(document.createElement('img'), { alt: '', decoding: 'async' }))
      tip.prepend(box)
    }
    const z = box.querySelector('img')
    // 読み込む前から高さを決めておく（読み込んだあとに吹き出しが伸びて、ヘッダーの下にもぐらないように）
    if (img.naturalWidth && img.naturalHeight) z.style.aspectRatio = `${img.naturalWidth} / ${img.naturalHeight}`
    const want = bigger(src)
    if (z.getAttribute('src') !== want) {
      z.onload = () => { if (label.matches(':hover') || label.classList.contains('is-tip')) placeTip(label) }
      z.setAttribute('src', want)
    }
  }
  // 画面の端からはみ出さないよう横にずらし、上に場所がなければ下に出す
  const placeTip = (label) => {
    const tip = label.querySelector('.gpo-tooltip')
    if (!tip) return
    ensureZoom(label)
    label.style.setProperty('--szk-tip-x', '0px')
    label.classList.remove('is-tip-below')
    const r = tip.getBoundingClientRect()
    const pad = 8
    const dx = r.left < pad ? pad - r.left : r.right > window.innerWidth - pad ? window.innerWidth - pad - r.right : 0
    if (dx) label.style.setProperty('--szk-tip-x', `${Math.round(dx)}px`)
    if (r.top < headerBottom() + pad) label.classList.add('is-tip-below')
  }
  let tipTimer = 0
  root.addEventListener('pointerup', (e) => {
    if (e.pointerType === 'mouse') return
    const label = e.target.closest?.('.gpo-swatches label')
    if (!label) return
    for (const l of root.querySelectorAll('.gpo-swatches label.is-tip')) if (l !== label) l.classList.remove('is-tip')
    label.classList.add('is-tip') // 先に出してから、位置を測る（しまっている間は場所を取らないため）
    placeTip(label)
    clearTimeout(tipTimer)
    tipTimer = setTimeout(() => label.classList.remove('is-tip'), label.querySelector('.gpo-tooltip__image img') ? 2600 : 1800)
  })
  root.addEventListener('mouseover', (e) => { const label = e.target.closest?.('.gpo-swatches label'); if (label) placeTip(label) })
  // スマホ：吹き出しの外をさわったら、すぐしまう
  document.addEventListener('pointerdown', (e) => {
    if (e.pointerType === 'mouse' || e.target.closest?.('.gpo-swatches label')) return
    for (const l of root.querySelectorAll('.gpo-swatches label.is-tip')) l.classList.remove('is-tip')
  }, { passive: true })

  // 在庫切れの追加料金の表示は szk-oos.js（大型だけでなく、すべての商品ページで読む）
})()
